/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaIstitutoPlessoDTO } from '../model/models';
import { TipoPraticaIstitutoPlessoCreationForm } from '../model/models';
import { TipoPraticaIstitutoPlessoDTO } from '../model/models';
import { TipoPraticaIstitutoPlessoListFilter } from '../model/models';
import { TipoPraticaIstitutoPlessoPatchForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTipoPraticaIstitutoPlessoRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    tipoPraticaIstitutoPlessoCreationForm: TipoPraticaIstitutoPlessoCreationForm;
}

export interface DeleteTipoPraticaIstitutoPlessoRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    idPlesso: string;
}

export interface GetTipoPraticaIstitutoPlessoRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    idPlesso: string;
}

export interface ListTipoPraticaIstitutoPlessiRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    filter: TipoPraticaIstitutoPlessoListFilter;
    pageable: Pageable;
}

export interface UpdateTipoPraticaIstitutoPlessoRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    idPlesso: string;
    tipoPraticaIstitutoPlessoPatchForm: TipoPraticaIstitutoPlessoPatchForm;
}


export interface TipoPraticaIstitutoPlessoControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea un nuovo Plesso sotto un Istituto
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi
* @param requestParameters
     */
    createTipoPraticaIstitutoPlesso(requestParameters: CreateTipoPraticaIstitutoPlessoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaIstitutoPlessoDTO>;

    /**
     * Elimina un Plesso (cascade su Assegnazioni)
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}
* @param requestParameters
     */
    deleteTipoPraticaIstitutoPlesso(requestParameters: DeleteTipoPraticaIstitutoPlessoRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di un Plesso per id
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}
* @param requestParameters
     */
    getTipoPraticaIstitutoPlesso(requestParameters: GetTipoPraticaIstitutoPlessoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaIstitutoPlessoDTO>;

    /**
     * Lista paginata dei Plessi di un Istituto (filtri: nome, ordinamento, codice_meccanografico, attivo, q)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi
* @param requestParameters
     */
    listTipoPraticaIstitutoPlessi(requestParameters: ListTipoPraticaIstitutoPlessiRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaIstitutoPlessoDTO>;

    /**
     * Replace di un Plesso (richiede version per optimistic lock)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}
* @param requestParameters
     */
    updateTipoPraticaIstitutoPlesso(requestParameters: UpdateTipoPraticaIstitutoPlessoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaIstitutoPlessoDTO>;

}
